import styled from "styled-components";

/**
 * Backdrop do diálogo
 * Fundo escuro que cobre toda a tela quando o diálogo está aberto.
 */
export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

/**
 * Container do diálogo
 * Posiciona o painel centralizado na tela.
 */
export const DialogContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
`;

/**
 * Painel do diálogo
 * Estilo do conteúdo principal do diálogo.
 */
export const DialogPanel = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.spacing(3)};
  max-width: 440px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: ${({ theme }) => theme.shadows.light.large};
  padding: ${({ theme }) => theme.spacing(3)};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: none;
    border-radius: ${({ theme }) => theme.spacing(3)} ${({ theme }) => theme.spacing(3)} 0 0;
    max-height: 90vh;
  }
`;

/**
 * Cabeçalho do diálogo
 * Contém o título e o botão de fechar.
 */
export const DialogHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

/**
 * Título do diálogo
 */
export const DialogTitle = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  flex: 1;
`;

/**
 * Botão de fechar
 */
export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: ${({ theme }) => theme.fontSizes.xl};
  color: ${({ theme }) => theme.colors.mediumGray};
  cursor: pointer;
  padding: 0;
  width: ${({ theme }) => theme.spacing(4)};
  height: ${({ theme }) => theme.spacing(4)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${({ theme }) => theme.spacing(2)};
  flex-shrink: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.black};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primaryColor};
    outline-offset: 2px;
    border-radius: ${({ theme }) => theme.spacing(0.75)};
  }
`;

/**
 * Conteúdo do diálogo
 */
export const DialogContent = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

/**
 * Rodapé do diálogo
 */
export const DialogFooter = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(2)};
`;
